import React from "react";
import { Card, Space, Typography, List } from "antd";

const { Text, Title } = Typography;

interface RfidColumnListProps {
  rfids?: string[];
}

const RfidColumnList: React.FC<RfidColumnListProps> = ({
  rfids,
}) => {
  return (
    <Card>
      <Space direction="vertical" className="rfid-container" size="large">
        <Title level={4} className="rfid-title">
          Total: {rfids?.length}
        </Title>

        <div className="rfid-list-wrapper">
          <List
            dataSource={rfids}
            renderItem={(rfid) => (
              <List.Item className="rfid-item">
                <Text>{rfid}</Text>
              </List.Item>
            )}
          />
        </div>
      </Space>
    </Card>
  );
};

export default RfidColumnList;
